<template>
  <div>
    <div class="input-container">
      <slot name="input" />
      <i class="icon" :class="icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomInput",
  props: ["icon"],
};
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}

/* Style the form icons */
.icon {
  color: var(--color-primary);
  padding: 10px;
  min-width: 50px;
  text-align: center;
}

/* Style the input fields */
.input-field {
  width: 100%;
  padding: 10px;
  outline: none;
}

.input-field:focus {
  border: 2px solid dodgerblue;
}

/* Set a style for the submit button */
.btn {
  background-color: dodgerblue;
  color: white;
  padding: 15px 20px;
  border: none;
  cursor: pointer;
  width: 100%;
  opacity: 0.9;
}

.btn:hover {
  opacity: 1;
}
</style>
